import { AlertTriangle } from 'lucide-react';
import { useCampaignStore } from '@/stores';
import { useOrganizationTypeConflicts } from '@/hooks/queries/useOrganizationTypeConflicts';

// Issue #350 — the small count on the contacts list linking through to the affected contacts. When
// one or more organization contacts have an unresolved contact-merge OrganizationType conflict, this
// amber banner surfaces the total and links to the first affected contact (where the inline fix-it
// alert resolves it, one at a time). Renders nothing when there are none, or for a non-Manage user.

interface OrganizationTypeConflictCountProps {
  onReview: (contactId: string) => void;
}

export function OrganizationTypeConflictCount({ onReview }: OrganizationTypeConflictCountProps) {
  const canManage = useCampaignStore((s) => s.canManage('Finance'));
  const conflictsRead = useOrganizationTypeConflicts();
  const data = conflictsRead.status === 'ready' ? conflictsRead.data : undefined;

  const conflicts = data?.conflicts ?? [];
  if (!canManage || conflicts.length === 0) return null;

  const n = conflicts.length;
  return (
    <button
      type="button"
      data-testid="org-type-conflict-count"
      onClick={() => onReview(conflicts[0].contactId)}
      className="flex w-full items-center gap-2 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-left text-sm text-amber-800 hover:bg-amber-100"
    >
      <AlertTriangle className="h-4 w-4 shrink-0" />
      <span>
        {n} organization {n === 1 ? 'contact has' : 'contacts have'} an unresolved organization-type
        conflict from a merge — review
      </span>
    </button>
  );
}
